import { createContext, useContext } from "react";
export const AssetCaptureContext = createContext(new Set());
export const useAssetCapture = () => {
    return useContext(AssetCaptureContext);
};
